// Centralized export for all constants used across the application
export * from './texts';

// Accounting and DAT are deprecated per CP2 User Access Definition v3 - removed from new
// assignment options. DAT members conceptually fold into DIG; existing users/assignments in
// either org are unaffected, this only governs what's offered going forward.
export const INTERNAL_USER_ORGANIZATION_MAP: Record<string, string> = {
  compliance: 'Compliance',
  dig: 'DIG',
  driverimplementationteam: 'DriverImplementationTeam',
  fieldops: 'FieldOps',
  productandengineering: 'ProductAndEngineering',
  smt: 'SMT'
};